import React, { useEffect, useMemo, useState } from 'react';
import { Button, Modal, Space, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { optionService } from '../services/option';
import {
  get_default_list_help_config,
  ListHelpConfig,
  merge_list_help_configs,
} from '../config/list-help-defaults';

interface ListHelpButtonProps {
  page_key: string;
}

const LIST_HELP_OPTION_KEY = 'list_page_help_configs';

const ListHelpButton: React.FC<ListHelpButtonProps> = ({ page_key }) => {
  const [open, setOpen] = useState(false);
  const [config, setConfig] = useState<ListHelpConfig | null>(get_default_list_help_config(page_key) ?? null);

  useEffect(() => {
    const load_config = async () => {
      try {
        const saved_configs = await optionService.get(LIST_HELP_OPTION_KEY, []);
        const merged_configs = merge_list_help_configs(Array.isArray(saved_configs) ? saved_configs : []);
        const matched_config = merged_configs.find((item) => item.page_key === page_key) ?? null;
        setConfig(matched_config);
      } catch (error) {
        console.error('加载常见问题配置失败:', error);
      }
    };

    load_config();
  }, [page_key]);

  const normalized_content = useMemo(() => {
    return String(config?.help_content || '').trim();
  }, [config?.help_content]);

  const rendered_content = useMemo(() => {
    if (!normalized_content) {
      return '';
    }

    if (normalized_content.includes('<')) {
      return normalized_content;
    }

    return normalized_content.replace(/\n/g, '<br />');
  }, [normalized_content]);

  if (!config || !normalized_content) {
    return null;
  }

  return (
    <>
      <Tooltip title={config.button_text || '帮助'}>
        <Button
          type="link"
          size="small"
          icon={<QuestionCircleOutlined />}
          onClick={() => setOpen(true)}
        />
      </Tooltip>

      <Modal
        title={config.modal_title || '帮助说明'}
        open={open}
        onCancel={() => setOpen(false)}
        footer={[
          <Button key="close" type="primary" onClick={() => setOpen(false)}>
            我知道了
          </Button>,
        ]}
        width={720}
      >
        <style>{`
            .list-help-content {
              line-height: 1.8;
              margin-top: 8px;
            }

            .list-help-content p,
            .list-help-content h2,
            .list-help-content h3,
            .list-help-content blockquote,
            .list-help-content ol,
            .list-help-content ul,
            .list-help-content li {
              margin-top: 0;
              margin-bottom: 0;
            }

            .list-help-content ol,
            .list-help-content ul {
              padding-left: 22px;
            }
          `}</style>
        <Space direction="vertical" size={16} style={{ width: '100%' }}>
          <div
            className="list-help-content"
            dangerouslySetInnerHTML={{ __html: rendered_content }}
          />
        </Space>
      </Modal>
    </>
  );
};

export default ListHelpButton;
